const ranking = {
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {},
};

export default ranking;
